import { mustBeAdmin } from "../util/auth";

import {
  loginRoute,
  verifyEmailRoute,
  setupPasswordRoute,
  forgotPasswordRoute,
  setPasswordRoute,
  signupRoute,
  calendarRoute,
  decisionRoute,
  onboardPayrollRoute,
  onboardUserRoute,
  onboardSuccessRoute,
  setupPayrollRoute,
  onboardformRoute,
  ChangePasswordRoute
} from "./user";
import {
  payrollRoute
} from "./payroll";
import {
  uploadCsvRoute,
  bankCodeRoute,
  QuickPayWalletRoute,
  onetimeUploadRoute,
  onetimePreviewRoute,
  onetimeWalletRoute
} from "./quickpay";
import { libraryRoutes } from "./library";
import { walletRoutes } from "./wallet";
import { referralRoutes } from "./referral";
import { messageRoute } from "./message";
import { documentRoutes } from "./document";
import { reportRoute, reportSummaryRoute } from "./report";
import { promotionRoute, addPromotionRoute } from "./promotion";
// import { queryRoute, issueQueryRoute, viewQueryRoute } from "./query";
import { employeeRoutes } from "./employee";
import { employeePortalRoutes } from "./portal";
import {
  JobseekerSignupRoute,
  JobseekerHomeRoute,
  JobseekerProfileRoute,
  JobseekerAvailablejobsRoute
} from "./jobseeker";
import { leaveRoute } from "./leave";
import { settingRoute, editAdminRoute, addAdminRoute } from "./settings";
import {
  benefitRoute,
  createHmoRoute,
  benefitSummaryRoute,
  hmoSummaryRoute
} from "./benefit";
import { hireRoute, invitedRoute, transferRoute } from "./recruit";

const Dashboard = () => import("../components/content/dashboard");
const Contact = () => import("../components/content/contact");
const Notfound = () => import("../components/content/notfound");
const Demo = () => import("../components/content/demo");
const CompanyDetails = () =>
  import("../components/content/company/companyDetails");

export const routes = [
  loginRoute,
  setupPasswordRoute,
  verifyEmailRoute,
  ChangePasswordRoute,
  forgotPasswordRoute,
  setPasswordRoute,
  signupRoute,
  calendarRoute,
  decisionRoute,
  onboardPayrollRoute,
  onboardformRoute,
  onboardUserRoute,
  onboardSuccessRoute,
  setupPayrollRoute,
  { path: "/", redirect: "/dashboard" },
  {
    path: "/dashboard",
    component: Dashboard,
    beforeEnter: mustBeAdmin
  },
  {
    path: "/contact",
    component: Contact,
    beforeEnter: mustBeAdmin
  },
  {
    path: "/demo",
    component: Demo
  },
  uploadCsvRoute,
  bankCodeRoute,
  QuickPayWalletRoute,
  onetimeUploadRoute,
  onetimePreviewRoute,
  payrollRoute,
  onetimeWalletRoute,
  libraryRoutes,
  employeeRoutes,
  employeePortalRoutes,
  JobseekerSignupRoute,
  JobseekerHomeRoute,
  JobseekerProfileRoute,
  JobseekerAvailablejobsRoute,
  leaveRoute,
  settingRoute,
  editAdminRoute,
  addAdminRoute,
  benefitRoute,
  createHmoRoute,
  benefitSummaryRoute,
  hmoSummaryRoute,
  // queryRoute,
  // issueQueryRoute,
  // viewQueryRoute,
  promotionRoute,
  addPromotionRoute,
  reportRoute,
  reportSummaryRoute,
  documentRoutes,
  referralRoutes,
  walletRoutes,
  messageRoute,
  hireRoute,
  invitedRoute,
  transferRoute,
  {
    path: "/company-details",
    component: CompanyDetails,
    // beforeEnter: ifAuthenticated
    beforeEnter: mustBeAdmin
  },
  {
    path: "*",
    component: Notfound,
    // beforeEnter: ifAuthenticated
    beforeEnter: mustBeAdmin
  }
];
